import {
  BaseConfirmPromptSizeEnum,
  BaseConfirmPromptTypeEnum,
} from "./enums/base-confirm-prompt-size.enum";
import { EdModalRef } from "@edenred/components/modals";
import { ActionResultModel } from "./models/action-result.model";

export abstract class ConfirmPromptAbstractComponent {
  protected readonly BaseConfirmPromptSizeEnum: typeof BaseConfirmPromptSizeEnum =
    BaseConfirmPromptSizeEnum;
  protected readonly BaseConfirmPromptTypeEnum: typeof BaseConfirmPromptTypeEnum =
    BaseConfirmPromptTypeEnum;
  protected readonly modalRef: EdModalRef<unknown>;
  protected readonly confirmPromptModel: any;

  protected constructor(modalRef: EdModalRef<unknown>, modalData?: any) {
    this.modalRef = modalRef;
    this.confirmPromptModel = modalData;
  }

  public onConfirmClick(event?: any): void {
    const actionResult: ActionResultModel = this.onConfirmAction(event);
    if (actionResult.closePrompt) {
      this.modalRef.close(actionResult.result);
    }
  }

  public onCloseClick(event?: any): void {
    const actionResult: ActionResultModel = this.onCloseAction(event);
    if (actionResult.closePrompt) {
      this.modalRef.close(actionResult.result);
    }
  }

  protected abstract onConfirmAction(event?: any): ActionResultModel;

  protected abstract onCloseAction(event?: any): ActionResultModel;

  public get title(): string | undefined {
    return this.confirmPromptModel?.title;
  }

  public get description(): string | undefined {
    return this.confirmPromptModel?.description;
  }
}
